/* Clarion Camping — hero firefly field.
   Canvas particle layer over the hero photograph: fireflies drifting across
   the full frame, plus campfire embers rising from the lower left. Fireflies
   ease away from the pointer and settle back. Skipped entirely under
   prefers-reduced-motion, and paused whenever the hero is off screen. */
(function () {
  function init(canvas) {
    if (!canvas || canvas.dataset.ccReady === '1') return;
    canvas.dataset.ccReady = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0;
    var h = 0;
    var flies = [];
    var embers = [];
    var pointer = { x: -9999, y: -9999, active: false };
    var running = false;
    var rafId = null;
    var t = 0;

    function makeGlow(r, g, b) {
      var s = 64;
      var off = document.createElement('canvas');
      off.width = off.height = s;
      var octx = off.getContext('2d');
      var grad = octx.createRadialGradient(s / 2, s / 2, 0, s / 2, s / 2, s / 2);
      grad.addColorStop(0, 'rgba(' + r + ',' + g + ',' + b + ',1)');
      grad.addColorStop(0.25, 'rgba(' + r + ',' + g + ',' + b + ',0.55)');
      grad.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
      octx.fillStyle = grad;
      octx.fillRect(0, 0, s, s);
      return off;
    }

    var glowFly = makeGlow(214, 245, 140);
    var glowEmber = makeGlow(255, 150, 70);

    function rand(a, b) {
      return a + Math.random() * (b - a);
    }

    function resize() {
      var rect = canvas.getBoundingClientRect();
      /* Fall back to the host section if the canvas has not been laid out yet. */
      var host = canvas.parentElement;
      var cw = rect.width || (host ? host.offsetWidth : 0);
      var ch = rect.height || (host ? host.offsetHeight : 0);
      if (!cw || !ch) return false;
      if (Math.abs(cw - w) < 2 && Math.abs(ch - h) < 2) return true;
      w = cw;
      h = ch;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      seed();
      return true;
    }

    function seed() {
      /* Density scales with area so a wide desktop hero fills edge to edge. */
      var target = Math.round(Math.min(90, Math.max(22, (w * h) / 16000)));
      flies = [];
      for (var i = 0; i < target; i++) flies.push(newFly(true));

      var eTarget = Math.round(Math.min(26, Math.max(8, w / 80)));
      embers = [];
      for (var j = 0; j < eTarget; j++) embers.push(newEmber(true));
    }

    function newFly(anywhere) {
      /* Bias downward a little — fireflies hang near the ground — but cover
         the whole frame, including the sky, so the effect reads across the
         entire photograph rather than one corner. */
      var bias = Math.pow(Math.random(), 0.72);
      return {
        x: rand(-20, w + 20),
        y: anywhere ? bias * h : rand(h * 0.55, h),
        vx: rand(-0.16, 0.16),
        vy: rand(-0.1, 0.1),
        ox: 0,
        oy: 0,
        r: rand(1.0, 2.6),
        phase: rand(0, Math.PI * 2),
        speed: rand(0.005, 0.018),
        wander: rand(0.0008, 0.0026)
      };
    }

    function newEmber(anywhere) {
      return {
        x: rand(0, w * 0.6),
        y: anywhere ? rand(0, h) : h + rand(0, 40),
        vy: rand(-0.5, -0.18),
        vx: rand(-0.12, 0.18),
        r: rand(0.7, 1.9),
        life: rand(0.5, 1),
        decay: rand(0.0012, 0.0035)
      };
    }

    function draw() {
      rafId = null;
      if (!running) return;
      t += 1;
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';

      var i;
      for (i = 0; i < embers.length; i++) {
        var em = embers[i];
        em.y += em.vy;
        em.x += em.vx + Math.sin((t + i * 40) * 0.01) * 0.16;
        em.life -= em.decay;
        if (em.life <= 0 || em.y < -20) {
          embers[i] = newEmber(false);
          continue;
        }
        var es = em.r * 13;
        ctx.globalAlpha = Math.max(0, em.life) * 0.5;
        ctx.drawImage(glowEmber, em.x - es / 2, em.y - es / 2, es, es);
      }

      for (i = 0; i < flies.length; i++) {
        var f = flies[i];

        f.vx += Math.sin((t + i * 90) * f.wander) * 0.012;
        f.vy += Math.cos((t + i * 57) * f.wander) * 0.01;
        f.vx *= 0.985;
        f.vy *= 0.985;
        f.x += f.vx;
        f.y += f.vy;

        if (pointer.active) {
          var dx = f.x - pointer.x;
          var dy = f.y - pointer.y;
          var d2 = dx * dx + dy * dy;
          if (d2 < 18000 && d2 > 0.5) {
            var d = Math.sqrt(d2);
            var push = (1 - d / 134) * 1.5;
            f.ox += (dx / d) * push;
            f.oy += (dy / d) * push;
          }
        }
        f.ox *= 0.92;
        f.oy *= 0.92;

        /* Wrap on every edge so the field stays evenly populated. */
        if (f.x < -30) f.x = w + 28;
        if (f.x > w + 30) f.x = -28;
        if (f.y < -30) f.y = h + 28;
        if (f.y > h + 30) f.y = -28;

        f.phase += f.speed;
        var pulse = 0.5 + 0.5 * Math.sin(f.phase);
        var alpha = 0.1 + pulse * pulse * 0.7;
        var size = f.r * (7 + pulse * 6);

        ctx.globalAlpha = alpha;
        ctx.drawImage(glowFly, f.x + f.ox - size / 2, f.y + f.oy - size / 2, size, size);
      }

      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
      rafId = window.requestAnimationFrame(draw);
    }

    function start() {
      if (running) return;
      if (!w || !h) {
        if (!resize()) return;
      }
      running = true;
      if (!rafId) rafId = window.requestAnimationFrame(draw);
    }

    function stop() {
      running = false;
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    var host = canvas.closest('[data-cc-section="hero"]') || canvas.parentElement;

    host.addEventListener('pointermove', function (e) {
      var rect = canvas.getBoundingClientRect();
      pointer.x = e.clientX - rect.left;
      pointer.y = e.clientY - rect.top;
      pointer.active = true;
    });
    host.addEventListener('pointerleave', function () {
      pointer.active = false;
      pointer.x = pointer.y = -9999;
    });

    /* The hero photograph loads async and the header height settles after
       first paint, so re-measure rather than trusting the initial rect. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { resize(); }).observe(host);
    }
    window.addEventListener('resize', function () {
      window.clearTimeout(canvas._ccRT);
      canvas._ccRT = window.setTimeout(resize, 160);
    });
    window.addEventListener('load', resize);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.02 }).observe(canvas);
    }

    resize();
    start();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-cc-fireflies]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();